export const FETCH_CONTRACT_DEACTIVATION_STATUS = "FETCH_CONTRACT_DEACTIVATION_STATUS"
export const UPDATE_CONTRACT_DEACTIVATION_STATUS = "UPDATE_CONTRACT_DEACTIVATION_STATUS"
export const DELETE_CONTRACT_DEACTIVATION_STATUS = "DELETE_CONTRACT_DEACTIVATION_STATUS"